import { CommonApi } from "api/common.api";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";

export const CityDBSearch: React.FC<{
  priceOnly?: boolean;
  label?: string;
  onSelect?: Function;
  error?: string;
  inputValue?: string;
  selectedCityId?: number;
  style?: any;
}> = (props) => {
  const [citiesState, setCitiesState] = React.useState<
    Array<{
      label: string;
      value: any;
    }>
  >([]);

  useEffect(() => {
    if (props.selectedCityId) {
      getCitiesByCityId(props.selectedCityId);
    }
  }, [props.selectedCityId]);

  const [cityInputValue, setCityInputValue] = useState("");

  useEffect(() => {
    if (props.inputValue) {
      setCityInputValue(props.inputValue);
    }
  }, [props.inputValue]);

  const getCitiesByCityId = async (cityId) => {
    const citiesList = await CommonApi.getDbCityByCityId({
      cityId,
    });

    if (citiesList?.data?.result?.length) {
      setCitiesState(
        citiesList.data.result.map((accomodation) => ({
          label: `${accomodation.city}, ${accomodation.country}`,
          value: accomodation.id,
        }))
      );
      setCityInputValue(
        `${citiesList.data.result[0].city}, ${citiesList.data.result[0].country}`
      );
    }
  };

  const getCities = async (city: string) => {
    if (city === "") {
      setCitiesState([]);
      return;
    }
    const citiesList = await CommonApi.getDbCities({
      city,
      priceOnly: props.priceOnly,
    });

    setCitiesState(
      citiesList.data.result.map((accomodation) => ({
        label: `${accomodation.city}, ${accomodation.country}`,
        value: accomodation.id,
      }))
    );
  };

  useEffect(() => {
    getCities("");
  }, []);

  return (
    <div>
      {props.label && <Form.Text>{props.label}</Form.Text>}
      <Select
        className={`${props.style?.searchActivity}`}
        onInputChange={(val) => {
          getCities(val);
          setCityInputValue(val);
        }}
        defaultValue={citiesState[0]}
        onChange={(val: any) => {
          if (props.onSelect && val) {
            props.onSelect(val.value);
          }
        }}
        inputValue={cityInputValue}
        placeholder="Search Cities"
        options={citiesState}
      />
      <Form.Control.Feedback type="invalid">
        {props?.error}
      </Form.Control.Feedback>
    </div>
  );
};
